import MojitoCore from 'mojito/core';
import MainAppImpl from './main-app.js';
import PropTypes from 'prop-types';

const { UIView } = MojitoCore.Presentation;

/**
 * Shared application shell: wraps the product in {@link https://github.com/preactjs/preact-iso#locationprovider|LocationProvider},
 * keeps the common Redux router slice in sync with preact-iso navigation, and mounts the Mojito {@link applications/common/routing/router.jsx|Router}
 * for `/` and `/*`.
 *
 * Pass `children` as a function `(location) => vnode` to render the root app controller (or any tree) for the active route.
 *
 * @class MainApp
 * @memberof Mojito.Applications.Common.Components
 */
/**
 * MainApp prop types.
 *
 * @property {Function} children - Render prop function invoked with the current preact-iso `location` for matched routes.
 *
 * @memberof Mojito.Applications.Common.Components.MainApp
 */
const propTypes = {
    children: PropTypes.func.isRequired,
};

export default UIView('MainApp', MainAppImpl, propTypes);
